import { RuleTypeImage, RuleScopeProperty } from '../consts';

const RuleKeyMarkAs = 'mark-as';

const RuleValueRemove = 'remove';
const RuleValueWaterMarkMajor = 'watermark-major';
const RuleValueWaterMarkMinor = 'watermark-minor';
const RuleValueDuplicate = 'duplicate';

const RuleValueNoInteriorPhotos = 'no-interior-photos';
const RuleValueNoExteriorPhotos = 'no-exterior-photos';
const RuleValueNoKitchenPhotos = 'no-kitchen-photos';
const RuleValueNoBedroomPhotos = 'no-bedroom-photos';
const RuleValueNoBathroomPhotos = 'no-bathroom-photos';
const RuleValueNoLoungePhotos = 'no-lounge-photos';

const allowedKeys = [
    RuleKeyMarkAs
];

const allowedKeyScopes = {
    [ RuleKeyMarkAs ]: [ RuleScopeProperty ]
};

const imgTemplate = {
    imageURL: null,
    value: null,
    key: null,
    type: RuleTypeImage,
    scope: ''
};

const groupTemplate = {
    key: null,
    type: RuleTypeImage,
    scope: ''
};

/**
 * @param {String} imageURL -
 * @param {String} key -
 */
const makeImageRule = ( base ) => {
    let rule = null;

    if ( !base.imageURL ) {
        return {
            rule: rule,
            error: new Error( 'invalid image URL' )
        };
    }

    if ( !( 'value' in base ) ) {
        return {
            rule: rule,
            error: new Error( 'missing rule key value' )
        };
    }

    if ( !allowedKeys.includes( base.key ) ) {
        return {
            rule: rule,
            error: new Error( `"${base.key}" is not a valid rule key` )
        };
    }

    if ( !( 'scope' in base ) ) {
        return {
            rule: rule,
            error: new Error( 'missing required key scope' )
        };
    }

    if ( !allowedKeyScopes[ base.key ].includes( base.scope ) ) {
        return {
            rule: rule,
            error: new Error( `scope "${base.scope}" is not supported for key ${base.key}` )
        };
    }

    if ( !( 'createdBy' in base ) ) {
        return {
            rule: rule,
            error: new Error( 'missing required key createdBy' )
        };
    }

    rule = {
        imageURL: base.imageURL,
        key: base.key,
        value: base.value,
        createdBy: base.createdBy,
        scope: base.scope
    };

    return {
        rule: Object.assign( {}, imgTemplate, rule ),
        error: null
    };
};

const makeImageGroupRule = ( base ) => {
    let rule = null;

    if ( !allowedKeys.includes( base.key ) ) {
        return {
            rule: rule,
            error: new Error( `"${base.key}" is not a valid rule key` )
        };
    }

    if ( !( 'scope' in base ) ) {
        return {
            rule: rule,
            error: new Error( 'missing required key scope' )
        };
    }

    if ( !allowedKeyScopes[ base.key ].includes( base.scope ) ) {
        return {
            rule: rule,
            error: new Error( `scope "${base.scope}" is not supported for key ${base.key}` )
        };
    }

    if ( !( 'createdBy' in base ) ) {
        return {
            rule: rule,
            error: new Error( 'missing required key createdBy' )
        };
    }

    rule = {
        key: base.key,
        value: base.value,
        createdBy: base.createdBy,
        scope: base.scope
    };

    return {
        rule: Object.assign( {}, groupTemplate, rule ),
        error: null
    };
};

export {
    makeImageRule,
    makeImageGroupRule,
    RuleKeyMarkAs,
    RuleValueRemove,
    RuleValueWaterMarkMajor,
    RuleValueWaterMarkMinor,
    RuleValueDuplicate,
    RuleValueNoInteriorPhotos,
    RuleValueNoExteriorPhotos,
    RuleValueNoKitchenPhotos,
    RuleValueNoBedroomPhotos,
    RuleValueNoBathroomPhotos,
    RuleValueNoLoungePhotos
};



// WEBPACK FOOTER //
// ./src/components/property-qc/rules/image.js